
/* Default chart colors */
exports.chartColors = [
    '#13b57a', '#724cd9', '#3b87f0', '#d98e4d', // original 4 colors
    '#b01030', '#3cb44b', '#d4b000', '#4363d8', 
    '#c06020', '#911eb4', '#2a9d9d', '#b026a9', 
    '#8cb800', '#c08080', '#008080', '#b080ff', 
    '#9a6324', '#d4c080', '#800000', '#70b080', 
    '#808000', '#d49060', '#6d28d9', '#808080', 
    '#c04040', '#2a9d8f', '#f4a261', '#7aa5a7', 
    '#457b9d', '#b02060'  
]

/* Default date filter */
exports.dateFilter = [
  {
    label: "Month",
    value: "month",
  },
  {
    label: "Quarter",
    value: "quarter",
  },
  {
    label: "Year",
    value: "year",
  },
  {
    label: "All",
    value: "all",
  },
]